module.exports = __webpack_public_path__ + "static/media/bread-slice.7d22302f.svg";